import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {ResultatExamenDossierTableRestApiService} from './resultat-examen-dossier-table.rest-api.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';

@Injectable({providedIn: 'root'})
export class ResultatExamenDossierTableMetierService implements IRecuperationListeDonneesMetier {
    @Autowired() restApi: ResultatExamenDossierTableRestApiService;
    @Autowired() formBuilder: FormBuilder;

    @Autowired() datePipe: DatePipe;


    requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
        return this.restApi.requeteRecuperationListeDonnees(data, args);
    }

    initialiserFormulaire<T>(datas: T | any, args?: any): FormGroup {
        const data: any = {
            inputSearch: null,
            selectTypeSearch: !!datas && !!datas.selectTypeSearch ? datas.selectTypeSearch : null,
        };

        return this.formBuilder.group({
            inputSearch: data.inputSearch,
            selectTypeSearch: data.selectTypeSearch,
        });
    }

    initialiserFormulaireMedecin<T>(datas: T | any, args?: any): FormGroup {
        const data: any = {
            medecin: !!datas && !!datas.medecin ? datas.medecin : null,
        };

        return this.formBuilder.group({
            medecin: [{value: data.medecin, disabled: true}, Validators.required],
        });
    }

}
